export default __webpack_public_path__ + "static/media/fios-mobile-03.38c1b283.jpg";